import { parseLink } from '@/components/Header/utils';
import { type ParsedLinkData } from '@/components/Header/utils/links';
import type { Header } from '@/payload/payload.types';

export type StructuredHeader = ReturnType<typeof structureHeaderLinkGroups>;

export const structureHeaderLinkGroups = (header: Header) => {
  return {
    ...header,
    navLinks:
      header.navLinks?.map((navLink) => {
        return {
          ...navLink,
          linkGroup: structureLinkGroup(navLink),
        };
      }) || [],
  };
};

const structureLinkGroup = (
  navLink: NonNullable<Header['navLinks']>[number],
) => {
  return (
    navLink.linkGroup
      ?.map((linkGroup) => {
        const link = parseLink(linkGroup.link, true);

        if (!link) return null;

        let links: ParsedLinkData['links'];

        if (link.links.length) {
          links = link.links;
        } else {
          links =
            (linkGroup.links
              ?.map((subItemLink) => {
                const parsedLink = parseLink(subItemLink.link);
                if (!parsedLink) return null;

                return {
                  ...parsedLink,
                  id: parsedLink.name,
                  newTab: parsedLink.newTab ?? false,
                };
              })
              .filter(Boolean) as ParsedLinkData['links']) || [];
        }

        if (!link.href && !links.length && !link.links.length) {
          return null;
        }

        return {
          id: navLink.id!,
          link,
          links,
        };
      })
      .filter(Boolean) || []
  );
};
